export default __webpack_public_path__ + "static/media/Icon feather-arrow-right.1ff99004.svg";